
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, CircularProgress, FormControl, InputLabel, Select, MenuItem, TextField, Paper } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { ObtenerEtapa } from '../../connections/catalogos/EtapaConnection';
import { ActualizarSubEtapa, AgregarSubEtapa, SubEtapas } from '../../connections/catalogos/SubEtapaConnection';

import { EtapaProps } from '../../interfaces/catalogos/EtapaInterface';
import { SubEtapaProps } from '../../interfaces/catalogos/SubEtapaInterface';

export const SubEtapaPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [idSubEtapa, setIdSubEtapa] = useState( 0 );
    const [SubEtapa, setSubEtapa] = useState<SubEtapaProps[]>( [] );

    const [etapa, setEtapa] = useState( 0 );
    const [etapaArray, setEtapaArray] = useState<EtapaProps[]>( [] );

    const [descripcion, setDescripcion] = useState( '' );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const [filtroEtapa, setFiltroEtapa] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( SubEtapa, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const fe = filtroEtapa.toLowerCase();
        return (
            ( filtro === '' || ( item.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroEtapa === '' || ( item.etapa?.descripcion?.toLowerCase().includes( fe ) ?? false ) )
        );
    });

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const SubEtapaselected = SubEtapa.find( (elem) => elem.idSubEtapa === id );

        if ( SubEtapaselected ) {

            await ActualizarSubEtapa({ ...SubEtapaselected, activo: checked }).then( resp => {

                if ( resp.idSubEtapa ) {

                    var newArray = SubEtapa.map( (elem) => {

                        if ( elem.idSubEtapa === id ) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setSubEtapa( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }

            });
        }

    }

    const handleGuardar = async () => {

        if ( idSubEtapa !== 0 ) {

            const SubEtapaSelected = SubEtapa.find( (elem) => elem.idSubEtapa === idSubEtapa );

            if ( SubEtapaSelected ) {

                setLoading( true );

                await ActualizarSubEtapa({ ...SubEtapaSelected, descripcion, idEtapa: etapa, }).then( resp => {

                    if ( resp.idSubEtapa ) {

                        setTimeout(() => {

                            var newArray = SubEtapa.map( (elem) => {

                                if ( elem.idSubEtapa === idSubEtapa ) {
                                    elem.descripcion = descripcion;
                                    elem.idEtapa = etapa;
                                    elem.etapa = resp.etapa;
                                }

                                return elem;
                            });

                            setSubEtapa( newArray );
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const subetapaAdd: SubEtapaProps = {
                idSubEtapa: 0,
                descripcion,
                idEtapa: etapa,
                activo: true,
            };

            setLoading( true );

            await AgregarSubEtapa( subetapaAdd ).then( resp => {

                if ( resp.idSubEtapa ) {

                    setTimeout(() => {

                        setSubEtapa( [...SubEtapa, resp] );
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó la sub etapa correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setSubEtapa( [] );

            await SubEtapas().then( resp => {

                setTimeout(() => {

                    setSubEtapa( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setEtapaArray( [] );

            await ObtenerEtapa().then( resp => {

                setTimeout(() => {

                    setEtapaArray( resp );

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Sub etapa' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 } >

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdSubEtapa( 0 );
                            setEtapa( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={ 2 }>

                <Grid size={{ xs: 12, md: 6 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>

                    <SearchTextField
                        value={ filtroEtapa }
                        label='Buscar por etapa'
                        onChange={ ( value ) => {
                            setFiltroEtapa( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '45%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%' }}> Etapa </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                    :
                                    dataFiltrada
                            )
                                .map( ({ idSubEtapa, descripcion, activo, idEtapa, etapa }) => (

                                    <TableRow key={ idSubEtapa } >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            { idSubEtapa }
                                        </TableCell>

                                        <TableCell>
                                            { descripcion }
                                        </TableCell>

                                        <TableCell>
                                            { etapa?.descripcion }
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={ activo }
                                                onChange={ (e) => handleChangeChecked( e.target.checked, idSubEtapa ) }
                                            />

                                            <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {

                                                    setIdSubEtapa( idSubEtapa );
                                                    setEtapa( idEtapa ? idEtapa : 0 );
                                                    setDescripcion( descripcion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: { dataFiltrada.length }
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Etapa</InputLabel>

                                <Select
                                    label='Etapa'
                                    value={ etapa }
                                    onChange={ (e) => setEtapa( parseInt(e.target.value.toString() ?? '0') ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        etapaArray.map( (elem) => (
                                            <MenuItem key={ elem.idEtapa } value={ elem.idEtapa }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={ 'Descripción' }
                                variant='outlined'
                                multiline
                                rows={ 4 }
                                fullWidth
                                value={ descripcion }
                                onChange={ (e) => setDescripcion( e.target.value ) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ etapa === 0 } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}
